import React, { useState } from 'react';
import {
    Button,
    Modal,
    Heading,
} from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import { notifyAdmin } from '../../util/api';
import Swal from 'sweetalert2';

import css from './GetAccessModal.module.css';



const GetAccessModal = (props) => {
    const {
        onClose,
        isOpen,
        onManageDisableScrolling
    } = props

    const [loading, setLoading] = useState(false);

    const handleGetAccess = async () => {
        setLoading(true);
        try {
            await notifyAdmin({
                notificationType: 'USER_REQUEST_PREMIUM_ACCESS',
            });
            setLoading(false);
              Swal.fire({
                      title: 'Success!',
                      text:'Your request for premium access has been successfully submitted. You will be notified once it is processed.',
                      icon: 'success',
                      showCloseButton: true,
                      showConfirmButton: false,
                    //   timer: 3000,
                    //   timerProgressBar: true,
                    });
                    onClose()
            
        } catch (error) {
            setLoading(false);
            console.error("Notification failed", error); 
        }
    };

    return  <Modal onClose={onClose}
            id="GetAccessModal"
            containerClassName={css.sellModal}
            isOpen={isOpen}
            closeButtonMessage={' '}
            usePortal
            onManageDisableScrolling={onManageDisableScrolling} >
            <div className={css.modalContainer}>
                <Heading as="h4">
                    <FormattedMessage id="GetAccessModal.title" />
                </Heading>
                <ul className={css.benefitsList}>
                    <li className={css.benefit}><FormattedMessage id="GetAccessModal.benefit 1" /></li>
                    <li className={css.benefit}><FormattedMessage id="GetAccessModal.benefit 2" /></li>
                    <li className={css.benefit}><FormattedMessage id="GetAccessModal.benefit 3" /></li>
                    <li className={css.benefit}><FormattedMessage id="GetAccessModal.benefit 4" /></li>
                </ul>

                <Button
                    onClick={handleGetAccess}
                    className={css.button}
                    disabled={loading}
                    inProgress={loading}
                >
                    <FormattedMessage id="GetAccessModal.button" />
                </Button>

            </div>
        </Modal>
}
export default GetAccessModal
